/* eslint-disable @typescript-eslint/ban-ts-comment */
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { getSingleCycle } from 'features/cycles/cyclesSlice'
import React from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Flex, ItemsGrid, ThinSeparator } from 'styling/GlobalStyles'
import { ICycleSingleResponse } from 'types/api/taskCyclesApi.interface'
import { IPhaseState, ITaskCycleBindingConfigState } from 'types/operationPlans.interface'

export const CycleTemplateType = ({ addingPhase, setAddingPhase }: { addingPhase: IPhaseState<ITaskCycleBindingConfigState>, setAddingPhase: React.Dispatch<React.SetStateAction<IPhaseState<ITaskCycleBindingConfigState>>> }) => {

    const dispatch = useDispatch<AppDispatch>()
    const parse = (data: any) => {
        return data ? data.data.map((item: any) => ({ label: item.name, value: item.id })) : []
    }

    const handleCycleSelect = async (value: ISelectValue) => {
        const resp = await dispatch(getSingleCycle(value.value.toString()))
        if (resp.meta.requestStatus === 'fulfilled') {
            // @ts-ignore 
            setAddingPhase(prev => ({
                ...prev, taskCycleTemplate: { label: value.label, value: value.value }, bindingConfig: {
                    startDate: null,
                    parallelismTarget: null,
                    department: null,
                    componentsData: (resp.payload as ICycleSingleResponse).components.map((component) => ({ taskCycleTemplateComponent: { label: component.name, value: component.id }, value: null }))
                }
            }))
        }

    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAddingPhase(prev => ({
            ...prev, bindingConfig: {
                ...prev.bindingConfig,
                [e.target.name]: e.target.value
            }
        }))
    }

    const handleComponentValue = (e: React.ChangeEvent<HTMLInputElement>, componentId: number | string) => {
        // @ts-ignore
        setAddingPhase(prev => ({
            ...prev, bindingConfig: {
                ...prev.bindingConfig, componentsData: prev.bindingConfig.componentsData.map(c => c.taskCycleTemplateComponent?.value === componentId ? { ...c, value: e.target.value } : c)
            }
        }))
    }

    return <>
        <Flex column gap='1rem' >
            <HonestSelectAsyncInput
                keyProp={1}
                defaultValue={addingPhase.taskCycleTemplate?.label}
                link='task/cycle/template'
                labelText='Task Cycle Template'
                onChange={handleCycleSelect}
                name='taskCycleTemplate'
                placeholder='Search Task Cycles'
                parserFunction={parse}
                required
                invalid={!addingPhase.taskCycleTemplate?.value}
            />
            {addingPhase.taskCycleTemplate?.value && <>
                <Flex gap='1rem' >
                    <CalendarInput
                        labelText='Start Date'
                        name='startDate'
                        onChange={date => setAddingPhase(prev => ({ ...prev, bindingConfig: { ...prev.bindingConfig, startDate: date } }))}
                        width='100%'
                    />
                    <Input width='100%' value={addingPhase.bindingConfig?.parallelismTarget} placeholder='Enter parallelism target' labelText='Parallelism Target' name='parallelismTarget' onChange={handleChange} nomargtype='number' />
                </Flex>
                <HonestSelectAsyncInput
                    link='departments'
                    placeholder='Search department'
                    name='department'
                    labelText='Department'
                    defaultValue={(addingPhase as IPhaseState<ITaskCycleBindingConfigState>)?.bindingConfig?.department?.label}
                    onChange={value => setAddingPhase(prev => ({ ...prev, bindingConfig: { ...prev.bindingConfig, department: value } }))}
                    parserFunction={(data: any) =>
                        data.data.map((i: any) => ({ label: i.name, value: i.id }))
                    }
                />
                <ThinSeparator />
                <ItemsGrid columns={2} >
                    {(addingPhase as IPhaseState<ITaskCycleBindingConfigState>)?.bindingConfig?.componentsData?.map(c =>
                        <Input value={c.value ?? ''} key={c.taskCycleTemplateComponent?.value} width='100%' placeholder='Enter value' labelText={c.taskCycleTemplateComponent.label + ' value'} name='value' onChange={e => handleComponentValue(e, c.taskCycleTemplateComponent?.value)} type='number' />
                    )}
                </ItemsGrid>
            </>}
        </Flex>

    </>
}